


















import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';

import SettingsWidget from '@/components/widgets/SettingsWidget.vue';
import EventBus from '@/services/eventbus.service';
import { Action, Getter } from 'vuex-class';

@Component({
  components: {
    SettingsWidget,
  },
})
export default class Widget extends Vue {
  @Prop() private data!: any;
  @Action private updateWidgetAsync: any;
  private flipped: boolean = false;
  private outerDiv: any = {};
  private mapLoading: boolean = false;

  private onResize() {
    this.outerDiv = this.$refs.outer;
  }

  private flipCard(id: string, widget: any) {
    this.flipped = !this.flipped;

    if (!this.flipped) {
      const currWidget = {...widget};
      delete currWidget.payload;
      EventBus.$emit('updateWidget', id, currWidget);
    }
  }

  private mounted() {
    EventBus.$on('updateWidget', (id: string, payload: object) => {
      if (this.data.id === id) {
        this.updateWidgetAsync({id, payload});
      }
    });
  }

  private beforeDestroy() {
    EventBus.$off('updateWidget');
  }
}
